import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactOverlayModal from 'react-overlays/Modal'
import { CloseIcon } from '../Icons'
import cssVariables from '../../styles/cssVariables'

const ModalStyled = styled(ReactOverlayModal)`
	position: fixed;
	z-index: 1040;
	top: 15%;
	left: 50%;
	transform: translateX(-50%);
	outline: 0;
	width: 100%;

	&:after {
		content: '';
		z-index: -1;
		position: absolute;
		left: 5%;
		right: 5%;
		top: 10%;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		filter: blur(40px);
	}
`

const ModalTitle = styled.div`
	background-color: ${cssVariables.color.brand.secondary};
	padding: ${cssVariables.spacing.lg} ${cssVariables.spacing.xxxxl};
	color: ${cssVariables.color.font.invert};
	font-weight: bold;
	font-size: ${cssVariables.fontSize.lg};
	position: relative;

	border-radius: ${cssVariables.borderRadius.lg} ${cssVariables.borderRadius.lg} 0 0;
`

const CloseIconStyled = styled(CloseIcon)`
	position: absolute;
	right: ${cssVariables.spacing.lg};
	cursor: pointer;
`

const ContentWrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: #ffffff;
	border-radius: ${cssVariables.borderRadius.lg};
`

const Content = styled.div`
	padding: ${cssVariables.spacing.lg};
	width: 100%;
`

const Backdrop = styled.div`
	position: fixed;
	z-index: 1040;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: ${cssVariables.color.brand.tertiary};
	opacity: 0.9;
`

export const Modal = ({
	open,
	onClose,
	closeOnBackdropClick = true,
	backdrop = false,
	title,
	children,
	className,
	...rest
}) => {
	const [show, setShow] = useState(open)

	useEffect(() => {
		setShow(open)
	}, [open])

	useEffect(() => {
		if (!!onClose && !show) onClose()
	}, [show])

	const handleHide = () => {
		setShow(false)
	}

	const handleOutsideClick = () => {
		if (closeOnBackdropClick) handleHide()
	}

	return (
		<ModalStyled
			show={show}
			renderBackdrop={backdrop ? () => <Backdrop onClick={handleOutsideClick} /> : undefined}
			backdrop={backdrop}
			onHide={handleHide}
			className={className}
			{...rest}
		>
			<ContentWrapper>
				{!!title && (
					<ModalTitle>
						{title} <CloseIconStyled invert onClick={handleHide} />
					</ModalTitle>
				)}
				<Content>{children}</Content>
			</ContentWrapper>
		</ModalStyled>
	)
}

Modal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	backdrop: PropTypes.bool,
	closeOnBackdropClick: PropTypes.bool,
	children: PropTypes.node,
	title: PropTypes.string,
	className: PropTypes.string,
}
